"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.animate = void 0;
var duration = 400;
var easeInOutSine = function (x) {
    return -(Math.cos(Math.PI * x) - 1) / 2;
};
exports.animate = function (callback, config) {
    var from = config.from, to = config.to, onRest = config.onRest;
    var start;
    var step = function () {
        var now = performance.now();
        if (!start)
            start = now;
        var progress = (now - start) / duration;
        if (progress < 1) {
            var value = ((to - from) * easeInOutSine(progress) + from).toString();
            callback(value);
            window.requestAnimationFrame(step);
        }
        else {
            callback(to.toString());
            if (onRest)
                onRest();
        }
    };
    window.requestAnimationFrame(step);
};
